<div class="display-board">

  <!-- ============ HEADER ============ -->
  <header class="board-header">
    <div class="brand">
      <img src="images/opensquash/sponsors/logo-bolar-white.png" alt="Bolar" class="logo">
      <div class="brand-bar"></div>
      <div class="brand-title">
        <h1>{{ tournamentName || 'Torneo' }}</h1>
        <div class="brand-meta">
          <span class="meta-item">
            <svg class="meta-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2"/>
              <path d="M16 2v4M8 2v4M3 10h18"/>
            </svg>
            {{ now | date:'EEEE d \'de\' MMMM' : '' : 'es-CO' }}
          </span>
          <span class="meta-item">
            <svg class="meta-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <path d="M12 6v6l4 2"/>
            </svg>
            {{ now | date:'h:mm a' : '' : 'es-CO' }}
          </span>
        </div>
      </div>
    </div>

    <div class="stats">
      <div class="stat-card">
        <div class="stat-icon stat-icon--live">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="8" r="4"/>
            <path d="M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1"/>
          </svg>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ matchesEnCancha.length }}</div>
          <div class="stat-label">En cancha</div>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon stat-icon--next">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="9" cy="7" r="4"/>
            <path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2"/>
            <circle cx="17" cy="7" r="4"/>
            <path d="M21 21v-2a4 4 0 0 0-3-3.87"/>
          </svg>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ totalPendientes }}</div>
          <div class="stat-label">Próximos hoy</div>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon stat-icon--done">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M6 9V2h12v7"/>
            <path d="M6 22h12"/>
            <path d="M12 16v6M8 22h8"/>
            <path d="M18 5h2a2 2 0 0 1 2 2v2a4 4 0 0 1-4 4M6 5H4a2 2 0 0 0-2 2v2a4 4 0 0 0 4 4"/>
          </svg>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ totalFinalizados }}</div>
          <div class="stat-label">Finalizados</div>
        </div>
      </div>
    </div>
  </header>

  <!-- ============ MAIN ============ -->
  <main class="board-main">

    <!-- ============ AHORA EN CANCHA ============ -->
    <section class="section section-en-cancha">
      <div class="section-head">
        <h2 class="section-title">
          <span class="dot live"></span>
          Ahora en cancha
        </h2>
        <div class="layout-toggle" role="group" aria-label="Modo de visualización">
          <button type="button" class="layout-btn"
                  [class.active]="enCanchaLayout === 'grid4'"
                  (click)="setEnCanchaLayout('grid4')"
                  title="Cuadrícula 2×2" aria-label="Cuadrícula">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="8" height="8" rx="1"/>
              <rect x="13" y="3" width="8" height="8" rx="1"/>
              <rect x="3" y="13" width="8" height="8" rx="1"/>
              <rect x="13" y="13" width="8" height="8" rx="1"/>
            </svg>
          </button>
          <button type="button" class="layout-btn"
                  [class.active]="enCanchaLayout === 'vertical'"
                  (click)="setEnCanchaLayout('vertical')"
                  title="Vertical (apilado)" aria-label="Vertical">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="4" y="3" width="16" height="5" rx="1"/>
              <rect x="4" y="10" width="16" height="5" rx="1"/>
              <rect x="4" y="17" width="16" height="4" rx="1"/>
            </svg>
          </button>
        </div>
        <span class="state-badge state-badge--live" *ngIf="matchesEnCancha.length > 0">EN JUEGO</span>
      </div>

      <div *ngIf="courtSlots.length === 0" class="empty">
        No hay canchas configuradas.
      </div>

      <div class="hero-stack" [class.hero-stack--grid4]="enCanchaLayout === 'grid4'"
                              [class.hero-stack--vertical]="enCanchaLayout === 'vertical'">
        <ng-container *ngFor="let slot of courtSlots; trackBy: trackBySlot">

          <!-- Cancha con partido en curso -->
          <div class="hero-card" *ngIf="slot.match as m"
               [style.--cat-color]="m.categoryColor">
            <div class="hero-tags">
              <span class="tag tag--court">Cancha {{ m.court || slot.name }}</span>
              <span class="tag tag--category" [style.background]="m.categoryColor">
                {{ categoryLabel(m.category) }}
              </span>
              <span class="tag tag--round" *ngIf="roundLabel(m.groupName)">{{ roundLabel(m.groupName) }}</span>
              <span class="hero-elapsed" *ngIf="elapsedSince(m)">{{ elapsedSince(m) }}</span>
            </div>

            <div class="hero-players">
              <div class="hero-player hero-player--p1" [class.is-winning]="gamesScore(m).p1 > gamesScore(m).p2">
                <div class="hero-avatar hero-avatar--p1">{{ getInitials(playerName(m, 'p1')) }}</div>
                <div class="hero-player-name">{{ playerName(m, 'p1') }}</div>
              </div>

              <div class="hero-score">
                <div class="hero-games">
                  <span class="games-num games-num--p1"
                        [class.is-winner]="gamesScore(m).p1 > gamesScore(m).p2">
                    {{ gamesScore(m).p1 }}
                  </span>
                  <span class="games-sep">-</span>
                  <span class="games-num games-num--p2"
                        [class.is-winner]="gamesScore(m).p2 > gamesScore(m).p1">
                    {{ gamesScore(m).p2 }}
                  </span>
                </div>
                <div class="hero-games-label">JUEGOS</div>
                <ng-container *ngIf="currentGamePoints(m) as cur">
                  <div class="hero-current">
                    <span class="current-num">{{ cur.p1 }}</span>
                    <span class="current-sep">-</span>
                    <span class="current-num">{{ cur.p2 }}</span>
                  </div>
                  <div class="hero-current-label">MARCADOR ACTUAL</div>
                </ng-container>
              </div>

              <div class="hero-player hero-player--p2" [class.is-winning]="gamesScore(m).p2 > gamesScore(m).p1">
                <div class="hero-player-name">{{ playerName(m, 'p2') }}</div>
                <div class="hero-avatar hero-avatar--p2">{{ getInitials(playerName(m, 'p2')) }}</div>
              </div>
            </div>
          </div>

          <!-- Cancha libre -->
          <div class="hero-card hero-card--free" *ngIf="!slot.match">
            <div class="hero-tags">
              <span class="tag tag--court">Cancha {{ slot.name }}</span>
              <span class="tag tag--free">Libre</span>
            </div>
            <div class="hero-free-body">
              <svg class="hero-free-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                   stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <rect x="3" y="5" width="18" height="14" rx="2"/>
                <path d="M3 12h18M12 5v14"/>
              </svg>
              <div class="hero-free-text">Disponible</div>
            </div>
          </div>

        </ng-container>
      </div>
    </section>

    <!-- ============ COLUMNA DERECHA ============ -->
    <aside class="board-side">

      <!-- RECIÉN FINALIZADOS -->
      <section class="section section-finalizados" *ngIf="matchesFinalizados.length > 0">
        <div class="section-head">
          <h2 class="section-title">
            <svg class="title-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/>
              <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/>
              <path d="M4 22h16"/>
              <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/>
              <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/>
              <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"/>
            </svg>
            Recién finalizados
          </h2>
        </div>

        <ul class="list-finalizados">
          <li class="row-finalizado" *ngFor="let m of matchesFinalizados; trackBy: trackById"
              [style.--cat-color]="m.categoryColor">
            <span class="fin-check" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12l5 5L20 7"/>
              </svg>
            </span>
            <span class="tag tag--category tag--small" [style.background]="m.categoryColor">
              {{ categoryLabel(m.category) }}
            </span>
            <span class="fin-name fin-name--p1" [class.is-winner]="winnerSide(m) === 'p1'">
              {{ playerName(m, 'p1') }}
            </span>
            <span class="fin-score">{{ finishedResult(m) }}</span>
            <span class="fin-name fin-name--p2" [class.is-winner]="winnerSide(m) === 'p2'">
              {{ playerName(m, 'p2') }}
            </span>
          </li>
        </ul>
      </section>

      <!-- PRÓXIMOS -->
      <section class="section section-proximos">
        <div class="section-head">
          <h2 class="section-title">
            <svg class="title-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <path d="M12 6v6l4 2"/>
            </svg>
            Próximos
          </h2>
          <span class="section-count" *ngIf="matchesProximos.length > 0">{{ matchesProximos.length }}</span>
        </div>

        <div *ngIf="matchesProximos.length === 0" class="empty">
          No hay próximos partidos.
        </div>

        <ul class="proximos-list">
          <li class="row-proximo" *ngFor="let m of visibleProximos; let i = index; trackBy: trackById"
              [style.--cat-color]="m.categoryColor"
              [class.blocked]="!m.playerAvailable">
            <div class="row-top">
              <span class="position">#{{ m.globalPosition || (i + 1) }}</span>
              <span class="tag tag--category tag--small" [style.background]="m.categoryColor">
                {{ categoryLabel(m.category) }}
              </span>
              <span class="tag tag--round tag--small" *ngIf="roundLabel(m.groupName)">
                {{ roundLabel(m.groupName) }}
              </span>
              <span class="row-time" [class.overdue]="isOverdue(m)" *ngIf="showScheduledTime && scheduledTime(m)">
                {{ scheduledTime(m) }}
              </span>
            </div>
            <div class="row-bottom">
              <span class="name">{{ playerName(m, 'p1') }}</span>
              <span class="vs">vs</span>
              <span class="name">{{ playerName(m, 'p2') }}</span>
            </div>
          </li>
        </ul>

        <button class="see-more-btn" *ngIf="hasMoreProximos" (click)="toggleProximos()">
          {{ expandedProximos ? 'Ver menos' : 'Ver más horarios' }}
          <svg class="chevron" [class.up]="expandedProximos" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M6 9l6 6 6-6"/>
          </svg>
        </button>
      </section>

    </aside>
  </main>

  <!-- ============ FOOTER ============ -->
  <footer class="board-footer">
    <div class="footer-update">
      <span class="update-pulse"></span>
      Última actualización {{ lastUpdatedText() }}
    </div>
    <div class="footer-coming-soon">
      <div class="qr-placeholder" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <rect x="3" y="3" width="7" height="7" rx="1"/>
          <rect x="14" y="3" width="7" height="7" rx="1"/>
          <rect x="3" y="14" width="7" height="7" rx="1"/>
          <path d="M14 14h3v3h-3zM18 18h3v3h-3zM14 19h2"/>
        </svg>
      </div>
      <div class="coming-text">
        <div class="coming-title">Busca tu partido desde tu celular</div>
        <div class="coming-subtitle">Próximamente — escanea el QR para ver tu próximo partido</div>
      </div>
    </div>
  </footer>
</div>
